import {Identity} from '../identity.interface';
import {InterestsDocumentMetaWithDate} from './interests-document.interface';

export class InterestsMetaModel implements InterestsDocumentMetaWithDate, Identity {
  public constructor(public id: string = '', public sortOrder: number = 0, public updatedAt: Date = new Date()) {}
}
